import axios, { AxiosInstance } from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL

const axiosInstance: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Enable cookies for refresh token
  headers: {
    'Content-Type': 'application/json',
  },
});

// Note: Token management and refresh logic is handled by tokenRefresh.service.ts
// The interceptors are set up there to avoid conflicts

export default axiosInstance;
